// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import Numeral from "numeral";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Set from "rescript/lib/es6/belt_Set.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Db$Coronate from "./Db.res.js";
import * as ReactFeather from "react-feather";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as Hooks$Coronate from "./Hooks.res.js";
import * as Utils$Coronate from "./Utils.res.js";
import * as Router$Coronate from "./Router.res.js";
import * as Window$Coronate from "./Window.res.js";
import * as Data_Id$Coronate from "./Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Externals$Coronate from "./Externals/Externals.res.js";
import * as Data_Player$Coronate from "./Data/Data_Player.res.js";
import * as Data_Rounds$Coronate from "./Data/Data_Rounds.res.js";
import * as Data_Ratings$Coronate from "./Data/Data_Ratings.res.js";
import VisuallyHidden from "@reach/visually-hidden";

var sortFirstName = {
  TAG: "GetString",
  _0: (function (x) {
      return x.firstName;
    })
};

var sortLastName = {
  TAG: "GetString",
  _0: (function (x) {
      return x.lastName;
    })
};

var sortRating = {
  TAG: "GetInt",
  _0: (function (x) {
      return x.rating;
    })
};

var sortMatchCount = {
  TAG: "GetInt",
  _0: (function (x) {
      return Data_Player$Coronate.NatInt.toInt(x.matchCount);
    })
};

function firstName(firstName$1) {
  if (firstName$1 === "") {
    return {
            TAG: "Error",
            _0: "First name is required"
          };
  } else {
    return {
            TAG: "Ok",
            _0: firstName$1
          };
  }
}

function lastName(lastName$1) {
  if (lastName$1 === "") {
    return {
            TAG: "Error",
            _0: "Last name is required"
          };
  } else {
    return {
            TAG: "Ok",
            _0: lastName$1
          };
  }
}

function rating(rating$1) {
  var rating$2 = Belt_Int.fromString(rating$1);
  if (rating$2 !== undefined) {
    return {
            TAG: "Ok",
            _0: rating$2
          };
  } else {
    return {
            TAG: "Error",
            _0: "Rating must be a number"
          };
  }
}

function matchCount(matchCount$1) {
  var i = Belt_Int.fromString(matchCount$1);
  if (i !== undefined) {
    return {
            TAG: "Ok",
            _0: Data_Player$Coronate.NatInt.fromInt(i)
          };
  } else {
    return {
            TAG: "Error",
            _0: "Match count must be a number"
          };
  }
}

var initial = {
  matchCount: "Pristine",
  rating: "Pristine",
  lastName: "Pristine",
  firstName: "Pristine"
};

function validateForm(param) {
  var fieldStatuses = param.fieldStatuses;
  var input = param.input;
  var result = fieldStatuses.matchCount;
  var matchCountResult;
  matchCountResult = typeof result !== "object" ? matchCount(input.matchCount) : result._0;
  var result$1 = fieldStatuses.rating;
  var ratingResult;
  ratingResult = typeof result$1 !== "object" ? rating(input.rating) : result$1._0;
  var result$2 = fieldStatuses.lastName;
  var lastNameResult;
  lastNameResult = typeof result$2 !== "object" ? lastName(input.lastName) : result$2._0;
  var result$3 = fieldStatuses.firstName;
  var firstNameResult;
  firstNameResult = typeof result$3 !== "object" ? firstName(input.firstName) : result$3._0;
  if (matchCountResult.TAG === "Ok" && ratingResult.TAG === "Ok" && lastNameResult.TAG === "Ok" && firstNameResult.TAG === "Ok") {
    return {
            TAG: "Valid",
            output: {
              firstName: firstNameResult._0,
              lastName: lastNameResult._0,
              rating: ratingResult._0,
              matchCount: matchCountResult._0
            },
            fieldStatuses: {
              matchCount: {
                TAG: "Dirty",
                _0: matchCountResult
              },
              rating: {
                TAG: "Dirty",
                _0: ratingResult
              },
              lastName: {
                TAG: "Dirty",
                _0: lastNameResult
              },
              firstName: {
                TAG: "Dirty",
                _0: firstNameResult
              }
            }
          };
  }
  return {
          TAG: "Invalid",
          fieldStatuses: {
            matchCount: {
              TAG: "Dirty",
              _0: matchCountResult
            },
            rating: {
              TAG: "Dirty",
              _0: ratingResult
            },
            lastName: {
              TAG: "Dirty",
              _0: lastNameResult
            },
            firstName: {
              TAG: "Dirty",
              _0: firstNameResult
            }
          }
        };
}

function useForm(initialInput) {
  var memoizedInitialState = React.useMemo((function () {
          return {
                  input: initialInput,
                  fieldStatuses: initial,
                  formStatus: "Editing"
                };
        }), [initialInput]);
  var match = React.useReducer((function (state, action) {
          if (typeof action !== "object") {
            switch (action) {
              case "BlurMatchCountField" :
                  var result = Utils$Coronate.FormHelper.validateFieldOnBlurWithValidator(state.input.matchCount, state.fieldStatuses.matchCount, matchCount);
                  if (result === undefined) {
                    return state;
                  }
                  var init = state.fieldStatuses;
                  return {
                          input: state.input,
                          fieldStatuses: {
                            matchCount: result,
                            rating: init.rating,
                            lastName: init.lastName,
                            firstName: init.firstName
                          },
                          formStatus: state.formStatus
                        };
              case "BlurRatingField" :
                  var result$1 = Utils$Coronate.FormHelper.validateFieldOnBlurWithValidator(state.input.rating, state.fieldStatuses.rating, rating);
                  if (result$1 === undefined) {
                    return state;
                  }
                  var init$1 = state.fieldStatuses;
                  return {
                          input: state.input,
                          fieldStatuses: {
                            matchCount: init$1.matchCount,
                            rating: result$1,
                            lastName: init$1.lastName,
                            firstName: init$1.firstName
                          },
                          formStatus: state.formStatus
                        };
              case "BlurLastNameField" :
                  var result$2 = Utils$Coronate.FormHelper.validateFieldOnBlurWithValidator(state.input.lastName, state.fieldStatuses.lastName, lastName);
                  if (result$2 === undefined) {
                    return state;
                  }
                  var init$2 = state.fieldStatuses;
                  return {
                          input: state.input,
                          fieldStatuses: {
                            matchCount: init$2.matchCount,
                            rating: init$2.rating,
                            lastName: result$2,
                            firstName: init$2.firstName
                          },
                          formStatus: state.formStatus
                        };
              case "BlurFirstNameField" :
                  var result$3 = Utils$Coronate.FormHelper.validateFieldOnBlurWithValidator(state.input.firstName, state.fieldStatuses.firstName, firstName);
                  if (result$3 === undefined) {
                    return state;
                  }
                  var init$3 = state.fieldStatuses;
                  return {
                          input: state.input,
                          fieldStatuses: {
                            matchCount: init$3.matchCount,
                            rating: init$3.rating,
                            lastName: init$3.lastName,
                            firstName: result$3
                          },
                          formStatus: state.formStatus
                        };
              case "Reset" :
                  return {
                          input: initialInput,
                          fieldStatuses: initial,
                          formStatus: "Editing"
                        };
              
            }
          } else {
            switch (action.TAG) {
              case "UpdateMatchCountField" :
                  var nextValue = action._0;
                  var init$4 = state.input;
                  var init$5 = state.fieldStatuses;
                  return {
                          input: {
                            firstName: init$4.firstName,
                            lastName: init$4.lastName,
                            rating: init$4.rating,
                            matchCount: nextValue
                          },
                          fieldStatuses: {
                            matchCount: {
                              TAG: "Dirty",
                              _0: matchCount(nextValue)
                            },
                            rating: init$5.rating,
                            lastName: init$5.lastName,
                            firstName: init$5.firstName
                          },
                          formStatus: state.formStatus
                        };
              case "UpdateRatingField" :
                  var nextValue$1 = action._0;
                  var init$6 = state.input;
                  var init$7 = state.fieldStatuses;
                  return {
                          input: {
                            firstName: init$6.firstName,
                            lastName: init$6.lastName,
                            rating: nextValue$1,
                            matchCount: init$6.matchCount
                          },
                          fieldStatuses: {
                            matchCount: init$7.matchCount,
                            rating: {
                              TAG: "Dirty",
                              _0: rating(nextValue$1)
                            },
                            lastName: init$7.lastName,
                            firstName: init$7.firstName
                          },
                          formStatus: state.formStatus
                        };
              case "UpdateLastNameField" :
                  var nextValue$2 = action._0;
                  var init$8 = state.input;
                  var init$9 = state.fieldStatuses;
                  return {
                          input: {
                            firstName: init$8.firstName,
                            lastName: nextValue$2,
                            rating: init$8.rating,
                            matchCount: init$8.matchCount
                          },
                          fieldStatuses: {
                            matchCount: init$9.matchCount,
                            rating: init$9.rating,
                            lastName: {
                              TAG: "Dirty",
                              _0: lastName(nextValue$2)
                            },
                            firstName: init$9.firstName
                          },
                          formStatus: state.formStatus
                        };
              case "UpdateFirstNameField" :
                  var nextValue$3 = action._0;
                  var init$10 = state.input;
                  var init$11 = state.fieldStatuses;
                  return {
                          input: {
                            firstName: nextValue$3,
                            lastName: init$10.lastName,
                            rating: init$10.rating,
                            matchCount: init$10.matchCount
                          },
                          fieldStatuses: {
                            matchCount: init$11.matchCount,
                            rating: init$11.rating,
                            lastName: init$11.lastName,
                            firstName: {
                              TAG: "Dirty",
                              _0: firstName(nextValue$3)
                            }
                          },
                          formStatus: state.formStatus
                        };
              case "Submit" :
                  var match = state.formStatus;
                  if (typeof match === "object") {
                    return state;
                  }
                  var match$1 = validateForm(state);
                  if (match$1.TAG === "Valid") {
                    return {
                            input: state.input,
                            fieldStatuses: match$1.fieldStatuses,
                            formStatus: {
                              TAG: "Submitting",
                              _0: match$1.output,
                              _1: action._0
                            }
                          };
                  } else {
                    return {
                            input: state.input,
                            fieldStatuses: match$1.fieldStatuses,
                            formStatus: "Editing"
                          };
                  }
              
            }
          }
        }), memoizedInitialState);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          var match = state.formStatus;
          if (typeof match === "object") {
            match._1(match._0);
            dispatch("Reset");
          }
          
        }), [state.formStatus]);
  return {
          state: state,
          dispatch: dispatch
        };
}

function updateRating(param, nextValue) {
  param.dispatch({
        TAG: "UpdateRatingField",
        _0: nextValue
      });
}

function updateLastName(param, nextValue) {
  param.dispatch({
        TAG: "UpdateLastNameField",
        _0: nextValue
      });
}

function updateFirstName(param, nextValue) {
  param.dispatch({
        TAG: "UpdateFirstNameField",
        _0: nextValue
      });
}

function blurRating(param) {
  param.dispatch("BlurRatingField");
}

function blurLastName(param) {
  param.dispatch("BlurLastNameField");
}

function blurFirstName(param) {
  param.dispatch("BlurFirstNameField");
}

function matchCountResult(param) {
  return Utils$Coronate.FormHelper.exposeFieldResult(param.state.fieldStatuses.matchCount);
}

function ratingResult(param) {
  return Utils$Coronate.FormHelper.exposeFieldResult(param.state.fieldStatuses.rating);
}

function lastNameResult(param) {
  return Utils$Coronate.FormHelper.exposeFieldResult(param.state.fieldStatuses.lastName);
}

function firstNameResult(param) {
  return Utils$Coronate.FormHelper.exposeFieldResult(param.state.fieldStatuses.firstName);
}

function input(param) {
  return param.state.input;
}

function dirty(param) {
  var match = param.state.fieldStatuses;
  var tmp = match.matchCount;
  if (typeof tmp === "object") {
    return true;
  }
  var tmp$1 = match.rating;
  if (typeof tmp$1 === "object") {
    return true;
  }
  var tmp$2 = match.lastName;
  if (typeof tmp$2 === "object") {
    return true;
  }
  var tmp$3 = match.firstName;
  if (typeof tmp$3 !== "object") {
    return false;
  } else {
    return true;
  }
}

function valid(param) {
  var match = validateForm(param.state);
  if (match.TAG === "Valid") {
    return true;
  } else {
    return false;
  }
}

function submitting(param) {
  var match = param.state.formStatus;
  if (typeof match !== "object") {
    return false;
  } else {
    return true;
  }
}

function submit(param, fn) {
  param.dispatch({
        TAG: "Submit",
        _0: fn
      });
}

function errorNotification(x) {
  if (x !== undefined && x.TAG !== "Ok") {
    return JsxRuntime.jsx(Utils$Coronate.$$Notification.make, {
                children: x._0,
                kind: "Error"
              });
  } else {
    return null;
  }
}

function PagePlayers$NewPlayerForm(props) {
  var addPlayerCallback = props.addPlayerCallback;
  var dispatch = props.dispatch;
  var form = useForm({
        firstName: "",
        lastName: "",
        rating: "1200",
        matchCount: "0"
      });
  var input$1 = input(form);
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("fieldset", {
                    children: [
                      JsxRuntime.jsx("legend", {
                            children: "Register a new player"
                          }),
                      JsxRuntime.jsxs("p", {
                            children: [
                              JsxRuntime.jsx("label", {
                                    children: "First name",
                                    htmlFor: "firstName"
                                  }),
                              JsxRuntime.jsx("input", {
                                    name: "firstName",
                                    required: true,
                                    type: "text",
                                    value: input$1.firstName,
                                    onBlur: (function (param) {
                                        blurFirstName(form);
                                      }),
                                    onChange: (function ($$event) {
                                        updateFirstName(form, $$event.target.value);
                                      })
                                  })
                            ]
                          }),
                      errorNotification(firstNameResult(form)),
                      JsxRuntime.jsxs("p", {
                            children: [
                              JsxRuntime.jsx("label", {
                                    children: "Last name",
                                    htmlFor: "lastName"
                                  }),
                              JsxRuntime.jsx("input", {
                                    name: "lastName",
                                    required: true,
                                    type: "text",
                                    value: input$1.lastName,
                                    onBlur: (function (param) {
                                        blurLastName(form);
                                      }),
                                    onChange: (function ($$event) {
                                        updateLastName(form, $$event.target.value);
                                      })
                                  })
                            ]
                          }),
                      errorNotification(lastNameResult(form)),
                      JsxRuntime.jsxs("p", {
                            children: [
                              JsxRuntime.jsx("label", {
                                    children: "Rating",
                                    htmlFor: "form-newplayer-rating"
                                  }),
                              JsxRuntime.jsx("input", {
                                    id: "form-newplayer-rating",
                                    name: "rating",
                                    required: true,
                                    type: "number",
                                    value: input$1.rating,
                                    onBlur: (function (param) {
                                        blurRating(form);
                                      }),
                                    onChange: (function ($$event) {
                                        updateRating(form, $$event.target.value);
                                      })
                                  })
                            ]
                          }),
                      errorNotification(ratingResult(form)),
                      JsxRuntime.jsx("p", {
                            children: JsxRuntime.jsx("button", {
                                  children: "Add",
                                  disabled: submitting(form) || !valid(form)
                                })
                          })
                    ]
                  }),
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  submit(form, (function (param) {
                          var id = Data_Id$Coronate.random();
                          dispatch({
                                TAG: "Set",
                                _0: id,
                                _1: {
                                  firstName: param.firstName,
                                  id: id,
                                  lastName: param.lastName,
                                  matchCount: param.matchCount,
                                  rating: param.rating,
                                  type_: "Person"
                                }
                              });
                          if (addPlayerCallback !== undefined) {
                            return addPlayerCallback(id);
                          }
                          
                        }));
                })
            });
}

var NewPlayerForm = {
  make: PagePlayers$NewPlayerForm
};

function detectSeparator(input) {
  var cleanInput = input.replace(/\r/g, "");
  var lines = cleanInput.split("\n");
  var sampleLines = Belt_Array.slice(Belt_Array.keep(lines, (function (line) {
              return line.trim() !== "";
            })), 0, 5);
  if (sampleLines.length === 0) {
    return "\t";
  }
  var separators = [
    [
      "\t",
      "tab"
    ],
    [
      ",",
      "comma"
    ],
    [
      ";",
      "semicolon"
    ]
  ];
  var scores = Belt_Array.map(separators, (function (param) {
          var sep = param[0];
          var counts = Belt_Array.map(sampleLines, (function (line) {
                  return line.split(sep).length;
                }));
          var hasValidLines = Belt_Array.some(counts, (function (count) {
                  return count >= 2;
                }));
          if (!hasValidLines) {
            return [
                    sep,
                    -1000.0
                  ];
          }
          var totalCount = Belt_Array.reduce(counts, 0, (function (acc, c) {
                  return acc + c | 0;
                }));
          var avgCount = totalCount / counts.length;
          var variance = Belt_Array.reduce(counts, 0.0, (function (acc, c) {
                  var diff = c - avgCount;
                  return acc + diff * diff;
                }));
          return [
                  sep,
                  avgCount * 10.0 - variance * 0.5
                ];
        }));
  return Belt_Array.reduce(scores, [
                "\t",
                -2000.0
              ], (function (best, current) {
                  if (current[1] > best[1]) {
                    return current;
                  } else {
                    return best;
                  }
                }))[0];
}

function parseInput(input) {
  var separator = detectSeparator(input);
  var lines = input.split("\n");
  var results = Belt_Array.mapWithIndex(lines, (function (i, line) {
          var lineNumber = i + 1 | 0;
          var cleanLine = line.replace(/\r/g, "").trim();
          if (cleanLine === "") {
            return ;
          }
          var parts = cleanLine.split(separator);
          var numParts = parts.length;
          if (numParts >= 3) {
            var firstName = Belt_Option.getWithDefault(Belt_Array.get(parts, 0), "");
            var lastName = Belt_Option.getWithDefault(Belt_Array.get(parts, 1), "");
            var ratingStr = Belt_Option.getWithDefault(Belt_Array.get(parts, 2), "");
            var firstNameTrimmed = firstName.trim();
            var lastNameTrimmed = lastName.trim();
            var ratingTrimmed = ratingStr.trim();
            if (firstNameTrimmed === "") {
              return {
                      TAG: "Error",
                      _0: "Line " + String(lineNumber) + ": First name is required"
                    };
            }
            if (lastNameTrimmed === "") {
              return {
                      TAG: "Error",
                      _0: "Line " + String(lineNumber) + ": Last name is required"
                    };
            }
            var rating = Belt_Int.fromString(ratingTrimmed);
            if (rating !== undefined) {
              return {
                      TAG: "Ok",
                      _0: {
                        firstName: firstNameTrimmed,
                        lastName: lastNameTrimmed,
                        rating: rating,
                        lineNumber: lineNumber
                      }
                    };
            } else {
              return {
                      TAG: "Error",
                      _0: "Line " + String(lineNumber) + ": Rating must be a number"
                    };
            }
          }
          if (numParts !== 2) {
            return {
                    TAG: "Error",
                    _0: "Line " + String(lineNumber) + ": Expected 2 or 3 columns (FirstName, LastName, Rating)"
                  };
          }
          var firstName$1 = Belt_Option.getWithDefault(Belt_Array.get(parts, 0), "");
          var lastName$1 = Belt_Option.getWithDefault(Belt_Array.get(parts, 1), "");
          var firstNameTrimmed$1 = firstName$1.trim();
          var lastNameTrimmed$1 = lastName$1.trim();
          if (firstNameTrimmed$1 === "") {
            return {
                    TAG: "Error",
                    _0: "Line " + String(lineNumber) + ": First name is required"
                  };
          } else if (lastNameTrimmed$1 === "") {
            return {
                    TAG: "Error",
                    _0: "Line " + String(lineNumber) + ": Last name is required"
                  };
          } else {
            return {
                    TAG: "Ok",
                    _0: {
                      firstName: firstNameTrimmed$1,
                      lastName: lastNameTrimmed$1,
                      rating: 1200,
                      lineNumber: lineNumber
                    }
                  };
          }
        }));
  var nonEmptyResults = Belt_Array.keepMap(results, (function (x) {
          return x;
        }));
  if (nonEmptyResults.length === 0) {
    return {
            TAG: "Invalid",
            _0: ["Please enter at least one player"]
          };
  }
  var errors = Belt_Array.keepMap(nonEmptyResults, (function (r) {
          if (r.TAG === "Ok") {
            return ;
          } else {
            return r._0;
          }
        }));
  if (errors.length !== 0) {
    return {
            TAG: "Invalid",
            _0: errors
          };
  }
  var players = Belt_Array.keepMap(nonEmptyResults, (function (r) {
          if (r.TAG === "Ok") {
            return r._0;
          }
          
        }));
  return {
          TAG: "Valid",
          _0: players
        };
}

function PagePlayers$BulkImportForm(props) {
  var onSuccess = props.onSuccess;
  var dispatch = props.dispatch;
  var match = React.useState(function () {
        return "";
      });
  var setInput = match[1];
  var input = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setParseResult = match$1[1];
  var parseResult = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setImporting = match$2[1];
  var importing = match$2[0];
  var handleFileUpload = function ($$event) {
    $$event.preventDefault();
    var reader = new FileReader();
    var onload = function (ev) {
      var content = ev.target.result;
      setInput(function (param) {
            return content;
          });
      setParseResult(function (param) {
            
          });
    };
    reader.onload = onload;
    reader.readAsText(Belt_Option.getWithDefault(Belt_Array.get($$event.currentTarget.files, 0), ""));
    $$event.currentTarget["value"] = "";
  };
  var handleSubmit = function ($$event) {
    $$event.preventDefault();
    var errors = parseInput(input);
    if (errors.TAG === "Valid") {
      var players = errors._0;
      setImporting(function (param) {
            return true;
          });
      Belt_Array.forEach(players, (function (p) {
              var id = Data_Id$Coronate.random();
              dispatch({
                    TAG: "Set",
                    _0: id,
                    _1: {
                      firstName: p.firstName,
                      id: id,
                      lastName: p.lastName,
                      matchCount: Data_Player$Coronate.NatInt.fromInt(0),
                      rating: p.rating,
                      type_: "Person"
                    }
                  });
            }));
      setParseResult(function (param) {
            return {
                    TAG: "Valid",
                    _0: players
                  };
          });
      setImporting(function (param) {
            return false;
          });
      if (onSuccess !== undefined) {
        return onSuccess();
      } else {
        return ;
      }
    }
    var errors$1 = errors._0;
    setParseResult(function (param) {
          return {
                  TAG: "Invalid",
                  _0: errors$1
                };
        });
  };
  var handlePreview = function ($$event) {
    $$event.preventDefault();
    setParseResult(function (param) {
          return parseInput(input);
        });
  };
  var tmp;
  if (parseResult !== undefined) {
    if (parseResult.TAG === "Valid") {
      var players = parseResult._0;
      tmp = JsxRuntime.jsxs(Utils$Coronate.$$Notification.make, {
            children: [
              JsxRuntime.jsx("p", {
                    children: JsxRuntime.jsx("strong", {
                          children: "Successfully imported " + String(players.length) + " player(s)!"
                        })
                  }),
              JsxRuntime.jsx("ul", {
                    children: Belt_Array.map(players, (function (p) {
                            return JsxRuntime.jsx("li", {
                                        children: p.firstName + " " + p.lastName + " (" + String(p.rating) + ")"
                                      }, String(p.lineNumber));
                          }))
                  })
            ],
            kind: "Success"
          });
    } else {
      tmp = JsxRuntime.jsxs(Utils$Coronate.$$Notification.make, {
            children: [
              JsxRuntime.jsx("p", {
                    children: JsxRuntime.jsx("strong", {
                          children: "Validation errors:"
                        })
                  }),
              JsxRuntime.jsx("ul", {
                    children: Belt_Array.map(parseResult._0, (function (error) {
                            return JsxRuntime.jsx("li", {
                                        children: error
                                      }, error);
                          }))
                  })
            ],
            kind: "Error"
          });
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx("form", {
              children: JsxRuntime.jsxs("fieldset", {
                    children: [
                      JsxRuntime.jsx("legend", {
                            children: "Bulk import players"
                          }),
                      JsxRuntime.jsx("p", {
                            children: JsxRuntime.jsx("label", {
                                  children: "Upload a file (CSV, TSV, or TXT):",
                                  htmlFor: "bulk-import-file"
                                })
                          }),
                      JsxRuntime.jsx("p", {
                            children: JsxRuntime.jsx("input", {
                                  id: "bulk-import-file",
                                  accept: ".csv,.tsv,.txt",
                                  type: "file",
                                  onChange: handleFileUpload
                                })
                          }),
                      JsxRuntime.jsx("p", {
                            children: "— OR —",
                            className: "caption-20",
                            style: {
                              textAlign: "center"
                            }
                          }),
                      JsxRuntime.jsx("p", {
                            children: JsxRuntime.jsx("label", {
                                  children: "Paste player data (tab, comma, or semicolon separated):",
                                  htmlFor: "bulk-import-textarea"
                                })
                          }),
                      JsxRuntime.jsx("p", {
                            children: "Format: One player per line. Separator will be auto-detected. Rating is optional (defaults to 1200).",
                            className: "caption-20"
                          }),
                      JsxRuntime.jsx("textarea", {
                            id: "bulk-import-textarea",
                            style: {
                              fontFamily: "monospace",
                              width: "100%"
                            },
                            placeholder: "John\tDoe\t1600\nJane\tSmith\t1450",
                            rows: 10,
                            value: input,
                            onChange: (function ($$event) {
                                setInput(function (param) {
                                      return $$event.target.value;
                                    });
                                setParseResult(function (param) {
                                      
                                    });
                              })
                          }),
                      JsxRuntime.jsxs("p", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Preview",
                                    type: "button",
                                    onClick: handlePreview
                                  }),
                              " ",
                              JsxRuntime.jsx("button", {
                                    children: importing ? "Importing..." : "Import All",
                                    disabled: importing,
                                    type: "submit"
                                  })
                            ]
                          }),
                      tmp
                    ]
                  }),
              onSubmit: handleSubmit
            });
}

function PagePlayers$PlayerList(props) {
  var __windowDispatch = props.windowDispatch;
  var configDispatch = props.configDispatch;
  var playersDispatch = props.playersDispatch;
  var players = props.players;
  var sortDispatch = props.sortDispatch;
  var sorted = props.sorted;
  var windowDispatch = __windowDispatch !== undefined ? __windowDispatch : (function (param) {
        
      });
  var dialog = Hooks$Coronate.useBool(false);
  var bulkDialog = Hooks$Coronate.useBool(false);
  React.useEffect((function () {
          windowDispatch({
                TAG: "SetTitle",
                _0: "Players"
              });
          return (function () {
                    windowDispatch({
                          TAG: "SetTitle",
                          _0: ""
                        });
                  });
        }), [windowDispatch]);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(ReactFeather.UserPlus, {}),
                                " Add a new player"
                              ],
                              onClick: (function (param) {
                                  dialog.setTrue();
                                })
                            }),
                        JsxRuntime.jsxs("button", {
                              children: [
                                JsxRuntime.jsx(ReactFeather.Users, {}),
                                " Bulk import players"
                              ],
                              onClick: (function (param) {
                                  bulkDialog.setTrue();
                                })
                            })
                      ],
                      className: "toolbar toolbar__left"
                    }),
                JsxRuntime.jsxs("table", {
                      children: [
                        JsxRuntime.jsx("caption", {
                              children: "Player roster"
                            }),
                        JsxRuntime.jsx("thead", {
                              children: JsxRuntime.jsxs("tr", {
                                    children: [
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                  children: "First name",
                                                  sortColumn: sortFirstName,
                                                  data: sorted,
                                                  dispatch: sortDispatch
                                                })
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                  children: "Last name",
                                                  sortColumn: sortLastName,
                                                  data: sorted,
                                                  dispatch: sortDispatch
                                                })
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                  children: "Rating",
                                                  sortColumn: sortRating,
                                                  data: sorted,
                                                  dispatch: sortDispatch
                                                })
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(Hooks$Coronate.SortButton.make, {
                                                  children: "Matches",
                                                  sortColumn: sortMatchCount,
                                                  data: sorted,
                                                  dispatch: sortDispatch
                                                })
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: JsxRuntime.jsx(VisuallyHidden, {
                                                  children: "Controls"
                                                })
                                          })
                                    ]
                                  })
                            }),
                        JsxRuntime.jsx("tbody", {
                              children: Belt_Array.map(sorted.table, (function (p) {
                                      return JsxRuntime.jsxs("tr", {
                                                  children: [
                                                    JsxRuntime.jsx("td", {
                                                          children: JsxRuntime.jsx(Router$Coronate.Link.make, {
                                                                children: Data_Player$Coronate.fullName(p),
                                                                to_: {
                                                                  TAG: "Player",
                                                                  _0: p.id
                                                                }
                                                              }),
                                                          className: "table__player",
                                                          colSpan: 2
                                                        }),
                                                    JsxRuntime.jsx("td", {
                                                          children: p.rating,
                                                          className: "table__number"
                                                        }),
                                                    JsxRuntime.jsx("td", {
                                                          children: Data_Player$Coronate.NatInt.toInt(p.matchCount),
                                                          className: "table__number"
                                                        }),
                                                    JsxRuntime.jsx("td", {
                                                          children: JsxRuntime.jsxs("button", {
                                                                children: [
                                                                  JsxRuntime.jsx(ReactFeather.Trash2, {}),
                                                                  JsxRuntime.jsx(VisuallyHidden, {
                                                                        children: "Delete " + Data_Player$Coronate.fullName(p)
                                                                      })
                                                                ],
                                                                className: "danger button-ghost",
                                                                onClick: (function ($$event) {
                                                                    var id = p.id;
                                                                    $$event.preventDefault();
                                                                    var playerOpt = Belt_Map.get(players, id);
                                                                    if (playerOpt === undefined) {
                                                                      return ;
                                                                    }
                                                                    var message = "Are you sure you want to delete " + Data_Player$Coronate.fullName(playerOpt) + "?";
                                                                    if (window.confirm(message)) {
                                                                      playersDispatch({
                                                                            TAG: "Del",
                                                                            _0: id
                                                                          });
                                                                      return configDispatch({
                                                                                  TAG: "DelAvoidSingle",
                                                                                  _0: id
                                                                                });
                                                                    }
                                                                    
                                                                  })
                                                              })
                                                        })
                                                  ]
                                                }, Data_Id$Coronate.toString(p.id));
                                    })),
                              className: "content"
                            })
                      ],
                      style: {
                        margin: "auto"
                      }
                    }),
                JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
                      isOpen: dialog.state,
                      onDismiss: (function () {
                          dialog.setFalse();
                        }),
                      ariaLabel: "New player form",
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Close",
                              className: "button-micro",
                              onClick: (function (param) {
                                  dialog.setFalse();
                                })
                            }),
                        JsxRuntime.jsx(PagePlayers$NewPlayerForm, {
                              dispatch: playersDispatch
                            })
                      ],
                      className: ""
                    }),
                JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
                      isOpen: bulkDialog.state,
                      onDismiss: (function () {
                          bulkDialog.setFalse();
                        }),
                      ariaLabel: "Bulk import players form",
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Close",
                              className: "button-micro",
                              onClick: (function (param) {
                                  bulkDialog.setFalse();
                                })
                            }),
                        JsxRuntime.jsx(PagePlayers$BulkImportForm, {
                              dispatch: playersDispatch,
                              onSuccess: (function () {
                                  bulkDialog.setFalse();
                                })
                            })
                      ],
                      className: ""
                    })
              ],
              className: "content-area"
            });
}

function succWins(t) {
  return {
          wins: t.wins + 1 | 0,
          losses: t.losses,
          draws: t.draws
        };
}

function succLosses(t) {
  return {
          wins: t.wins,
          losses: t.losses + 1 | 0,
          draws: t.draws
        };
}

function percent(a, b) {
  var x = b !== 0 ? a / b : 0.0;
  return Numeral(x).format("%");
}

function PagePlayers$PlayerStats(props) {
  var playerId = props.playerId;
  var match = Db$Coronate.useAllTournaments();
  var match$1 = Belt_Map.reduce(match.items, {
        wins: 0,
        losses: 0,
        draws: 0
      }, (function (acc, _id, tournament) {
          return Belt_Array.reduce(Data_Rounds$Coronate.toArray(tournament.roundList), acc, (function (acc, round) {
                        return Belt_Array.reduce(Data_Rounds$Coronate.Round.toArray(round), acc, (function (acc, match) {
                                      var match$1 = match.result;
                                      var match$2 = Data_Id$Coronate.eq(playerId, match.blackId);
                                      var match$3 = Data_Id$Coronate.eq(playerId, match.whiteId);
                                      var exit = 0;
                                      switch (match$1) {
                                        case "Draw" :
                                            if (match$3 || match$2) {
                                              return {
                                                      wins: acc.wins,
                                                      losses: acc.losses,
                                                      draws: acc.draws + 1 | 0
                                                    };
                                            } else {
                                              return acc;
                                            }
                                        case "BlackWon" :
                                        case "WhiteAborted" :
                                            exit = 1;
                                            break;
                                        case "WhiteWon" :
                                        case "BlackAborted" :
                                            exit = 2;
                                            break;
                                        case "Aborted" :
                                        case "NotSet" :
                                            return acc;
                                        
                                      }
                                      switch (exit) {
                                        case 1 :
                                            if (match$2) {
                                              return succWins(acc);
                                            } else if (match$3) {
                                              return succLosses(acc);
                                            } else {
                                              return acc;
                                            }
                                        case 2 :
                                            if (match$3) {
                                              return succWins(acc);
                                            } else if (match$2) {
                                              return succLosses(acc);
                                            } else {
                                              return acc;
                                            }
                                        
                                      }
                                    }));
                      }));
        }));
  var draws = match$1.draws;
  var losses = match$1.losses;
  var wins = match$1.wins;
  var total = (wins + losses | 0) + draws | 0;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("table", {
                      children: [
                        JsxRuntime.jsx("thead", {
                              children: JsxRuntime.jsxs("tr", {
                                    children: [
                                      JsxRuntime.jsx("th", {
                                            children: "Stat"
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: "Count"
                                          }),
                                      JsxRuntime.jsx("th", {
                                            children: "Ratio"
                                          })
                                    ]
                                  })
                            }),
                        JsxRuntime.jsxs("tbody", {
                              children: [
                                JsxRuntime.jsxs("tr", {
                                      children: [
                                        JsxRuntime.jsx("th", {
                                              children: "Won",
                                              scope: "row"
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: wins,
                                              className: "table__number"
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: percent(wins, total),
                                              className: "table__number"
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsxs("tr", {
                                      children: [
                                        JsxRuntime.jsx("th", {
                                              children: "Lost",
                                              scope: "row"
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: losses,
                                              className: "table__number"
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: percent(losses, total),
                                              className: "table__number"
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsxs("tr", {
                                      children: [
                                        JsxRuntime.jsx("th", {
                                              children: "Drew",
                                              scope: "row"
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: draws,
                                              className: "table__number"
                                            }),
                                        JsxRuntime.jsx("td", {
                                              children: percent(draws, total),
                                              className: "table__number"
                                            })
                                      ]
                                    })
                              ]
                            })
                      ],
                      style: {
                        margin: "0"
                      }
                    }),
                JsxRuntime.jsx("p", {
                      children: "These statistics are generated from current tournament data. Their total may differ from\n          the \"matches played\" number above.",
                      className: "caption-20"
                    })
              ]
            });
}

function PagePlayers$AvoidForm(props) {
  var configDispatch = props.configDispatch;
  var players = props.players;
  var playerId = props.playerId;
  var avoidMap = Data_Id$Coronate.Pair.$$Set.toMap(props.config.avoidPairs);
  var singAvoidList = Belt_Map.getWithDefault(avoidMap, playerId, Belt_Set.make(Data_Id$Coronate.id));
  var unavoided = Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Array.keep(Belt_Map.keysToArray(players), (function (id) {
                  if (Belt_Set.has(singAvoidList, id)) {
                    return false;
                  } else {
                    return !Data_Id$Coronate.eq(id, playerId);
                  }
                })), (function (extra) {
              return Data_Player$Coronate.getMaybe(players, extra);
            })), Data_Player$Coronate.compareName);
  var match = React.useState(function () {
        
      });
  var setSelectedAvoider = match[1];
  var selectedAvoider = match[0];
  var selectedAvoider$1 = selectedAvoider !== undefined ? selectedAvoider : Belt_Array.get(unavoided, 0);
  var avoidAdd = function ($$event) {
    $$event.preventDefault();
    if (selectedAvoider$1 === undefined) {
      return ;
    }
    var pair = Data_Id$Coronate.Pair.make(playerId, selectedAvoider$1.id);
    if (pair !== undefined) {
      configDispatch({
            TAG: "AddAvoidPair",
            _0: Caml_option.valFromOption(pair)
          });
      return setSelectedAvoider(function (param) {
                  
                });
    }
    
  };
  var handleAvoidChange = function ($$event) {
    var id = $$event.currentTarget.value;
    setSelectedAvoider(function (param) {
          return Belt_Map.get(players, id);
        });
  };
  var handleAvoidBlur = function ($$event) {
    var id = $$event.currentTarget.value;
    setSelectedAvoider(function (param) {
          return Belt_Map.get(players, id);
        });
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                Belt_Set.isEmpty(singAvoidList) ? JsxRuntime.jsx("p", {
                        children: "None"
                      }) : JsxRuntime.jsx("ul", {
                        children: Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.map(Belt_Set.toArray(singAvoidList), (function (extra) {
                                        return Data_Player$Coronate.getMaybe(players, extra);
                                      })), Data_Player$Coronate.compareName), (function (p) {
                                var fullName = Data_Player$Coronate.fullName(p);
                                return JsxRuntime.jsxs("li", {
                                            children: [
                                              fullName,
                                              JsxRuntime.jsx("button", {
                                                    children: JsxRuntime.jsx(ReactFeather.Trash2, {}),
                                                    "aria-label": "Remove " + fullName + " from avoid list.",
                                                    className: "danger button-ghost",
                                                    title: "Remove " + fullName + " from avoid list.",
                                                    onClick: (function (param) {
                                                        var pair = Data_Id$Coronate.Pair.make(playerId, p.id);
                                                        if (pair !== undefined) {
                                                          return configDispatch({
                                                                      TAG: "DelAvoidPair",
                                                                      _0: Caml_option.valFromOption(pair)
                                                                    });
                                                        }
                                                        
                                                      })
                                                  })
                                            ]
                                          }, Data_Id$Coronate.toString(p.id));
                              }))
                      }),
                JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Select a new player to avoid.",
                              htmlFor: "avoid-select"
                            }),
                        selectedAvoider$1 !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                children: [
                                  JsxRuntime.jsx("select", {
                                        children: Belt_Array.map(unavoided, (function (p) {
                                                var id = Data_Id$Coronate.toString(p.id);
                                                return JsxRuntime.jsx("option", {
                                                            children: Data_Player$Coronate.fullName(p),
                                                            value: id
                                                          }, id);
                                              })),
                                        id: "avoid-select",
                                        value: Data_Id$Coronate.toString(selectedAvoider$1.id),
                                        onBlur: handleAvoidBlur,
                                        onChange: handleAvoidChange
                                      }),
                                  " ",
                                  JsxRuntime.jsx("input", {
                                        className: "button-micro",
                                        type: "submit",
                                        value: "Add"
                                      })
                                ]
                              }) : "No players are available to avoid."
                      ],
                      onSubmit: avoidAdd
                    })
              ]
            });
}

function PagePlayers$Profile(props) {
  var __windowDispatch = props.windowDispatch;
  var playersDispatch = props.playersDispatch;
  var player = props.player;
  var windowDispatch = __windowDispatch !== undefined ? __windowDispatch : (function (param) {
        
      });
  var type_ = player.type_;
  var rating = player.rating;
  var initialMatchCount = player.matchCount;
  var playerId = player.id;
  var form = useForm({
        firstName: player.firstName,
        lastName: player.lastName,
        rating: String(rating),
        matchCount: Data_Player$Coronate.NatInt.toString(initialMatchCount)
      });
  var input$1 = input(form);
  var playerName = input$1.firstName + " " + input$1.lastName;
  React.useEffect((function () {
          windowDispatch({
                TAG: "SetTitle",
                _0: "Profile for " + playerName
              });
          return (function () {
                    windowDispatch({
                          TAG: "SetTitle",
                          _0: ""
                        });
                  });
        }), [
        windowDispatch,
        playerName
      ]);
  var match = matchCountResult(form);
  var tmp;
  tmp = match !== undefined && match.TAG === "Ok" ? Data_Ratings$Coronate.EloRank.getKFactor(match._0, rating) : Data_Ratings$Coronate.EloRank.getKFactor(initialMatchCount, rating);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(Router$Coronate.Link.make, {
                      children: [
                        JsxRuntime.jsx(ReactFeather.ChevronLeft, {}),
                        " Back"
                      ],
                      to_: "PlayerList",
                      onClick: (function ($$event) {
                          if (dirty(form) && !window.confirm("Discard changes?")) {
                            $$event.preventDefault();
                            return ;
                          }
                          
                        })
                    }),
                JsxRuntime.jsx("h2", {
                      children: "Profile for " + playerName
                    }),
                JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsxs("p", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "First name",
                                      htmlFor: "firstName"
                                    }),
                                JsxRuntime.jsx("input", {
                                      name: "firstName",
                                      type: "text",
                                      value: input$1.firstName,
                                      onBlur: (function (param) {
                                          blurFirstName(form);
                                        }),
                                      onChange: (function ($$event) {
                                          updateFirstName(form, $$event.target.value);
                                        })
                                    })
                              ]
                            }),
                        errorNotification(firstNameResult(form)),
                        JsxRuntime.jsxs("p", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Last name",
                                      htmlFor: "lastName"
                                    }),
                                JsxRuntime.jsx("input", {
                                      name: "lastName",
                                      type: "text",
                                      value: input$1.lastName,
                                      onBlur: (function (param) {
                                          blurLastName(form);
                                        }),
                                      onChange: (function ($$event) {
                                          updateLastName(form, $$event.target.value);
                                        })
                                    })
                              ]
                            }),
                        errorNotification(lastNameResult(form)),
                        JsxRuntime.jsxs("p", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Matches played",
                                      htmlFor: "matchCount"
                                    }),
                                JsxRuntime.jsx("input", {
                                      name: "matchCount",
                                      type: "number",
                                      value: input$1.matchCount,
                                      onBlur: (function (param) {
                                          form.dispatch("BlurMatchCountField");
                                        }),
                                      onChange: (function ($$event) {
                                          var nextValue = $$event.target.value;
                                          form.dispatch({
                                                TAG: "UpdateMatchCountField",
                                                _0: nextValue
                                              });
                                        })
                                    })
                              ]
                            }),
                        errorNotification(matchCountResult(form)),
                        JsxRuntime.jsxs("p", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Rating",
                                      htmlFor: "rating"
                                    }),
                                JsxRuntime.jsx("input", {
                                      name: "rating",
                                      type: "number",
                                      value: input$1.rating,
                                      onBlur: (function (param) {
                                          blurRating(form);
                                        }),
                                      onChange: (function ($$event) {
                                          updateRating(form, $$event.target.value);
                                        })
                                    })
                              ]
                            }),
                        errorNotification(ratingResult(form)),
                        JsxRuntime.jsx("p", {
                              children: JsxRuntime.jsx("button", {
                                    children: dirty(form) ? "Save" : "Saved",
                                    disabled: submitting(form) || !valid(form)
                                  })
                            })
                      ],
                      onSubmit: (function ($$event) {
                          $$event.preventDefault();
                          submit(form, (function (param) {
                                  playersDispatch({
                                        TAG: "Set",
                                        _0: playerId,
                                        _1: {
                                          firstName: param.firstName,
                                          id: playerId,
                                          lastName: param.lastName,
                                          matchCount: param.matchCount,
                                          rating: param.rating,
                                          type_: type_
                                        }
                                      });
                                }));
                        })
                    }),
                JsxRuntime.jsx("h3", {
                      children: "Players to avoid"
                    }),
                JsxRuntime.jsx(PagePlayers$AvoidForm, {
                      playerId: playerId,
                      players: props.players,
                      config: props.config,
                      configDispatch: props.configDispatch
                    }),
                JsxRuntime.jsx("hr", {}),
                JsxRuntime.jsx("h3", {
                      children: "Statistics"
                    }),
                JsxRuntime.jsx(PagePlayers$PlayerStats, {
                      playerId: playerId
                    }),
                JsxRuntime.jsx("hr", {}),
                JsxRuntime.jsxs("details", {
                      children: [
                        JsxRuntime.jsx("summary", {
                              children: "Additional information"
                            }),
                        JsxRuntime.jsxs("dl", {
                              children: [
                                JsxRuntime.jsx("dt", {
                                      children: "K-factor"
                                    }),
                                JsxRuntime.jsx("dd", {
                                      children: tmp,
                                      className: "monospace"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("p", {
                              children: "K-factor is 40 for players who have played fewer than 30 matches, 20 for players with\n            a rating below 2100, and 10 for players with a rating above 2100.",
                              className: "caption-20"
                            })
                      ]
                    })
              ],
              className: "content-area"
            });
}

var Profile = {
  make: PagePlayers$Profile
};

function PagePlayers(props) {
  var windowDispatch = props.windowDispatch;
  var id = props.id;
  var match = Db$Coronate.useAllPlayers();
  var playersDispatch = match.dispatch;
  var players = match.items;
  var match$1 = Hooks$Coronate.useSortedTable(Belt_Map.valuesToArray(players), sortFirstName, false);
  var sortDispatch = match$1[1];
  React.useEffect((function () {
          sortDispatch({
                TAG: "SetTable",
                _0: Belt_Map.valuesToArray(players)
              });
        }), [
        players,
        sortDispatch
      ]);
  var match$2 = Db$Coronate.useConfig();
  var configDispatch = match$2[1];
  var tmp;
  if (id !== undefined) {
    var player = Belt_Map.get(players, Caml_option.valFromOption(id));
    tmp = player !== undefined ? JsxRuntime.jsx(PagePlayers$Profile, {
            player: player,
            players: players,
            playersDispatch: playersDispatch,
            config: match$2[0],
            configDispatch: configDispatch,
            windowDispatch: windowDispatch
          }) : JsxRuntime.jsx("div", {
            children: "Loading..."
          });
  } else {
    tmp = JsxRuntime.jsx(PagePlayers$PlayerList, {
          sorted: match$1[0],
          sortDispatch: sortDispatch,
          players: players,
          playersDispatch: playersDispatch,
          configDispatch: configDispatch,
          windowDispatch: windowDispatch
        });
  }
  return JsxRuntime.jsx(Window$Coronate.Body.make, {
              children: tmp,
              windowDispatch: windowDispatch
            });
}

var make = PagePlayers;

export {
  NewPlayerForm ,
  Profile ,
  make ,
}
/* react Not a pure module */
